export default "__VITE_ASSET__8a2f59a9__"